module.exports = "/integrations/connectCodeModal/template-b3391d.html";